<script setup lang="ts">

import { sk, cs } from "date-fns/locale";
import { subDays, endOfDay } from "date-fns";
import { VueDatePicker } from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import {watch} from "vue";
import {useLocaleStore} from "@/stores/l10n";

const localeStore = useLocaleStore()

const model = defineModel<Date | null>()

const props = defineProps<{
    id: string,
    label?: string,
    disabled?: boolean,
    required?: boolean,
    daysBack?: number,
    error?: string,
}>()

const emit = defineEmits(['clearError'])

const maxAllowedDate = endOfDay(new Date())
const minAllowedDate = props.daysBack ? subDays(maxAllowedDate, props.daysBack) : undefined

watch(model, () => emit('clearError'))

</script>

<template>
    <div class="space-y-4">
        <label :for="id">{{ label }}<span v-if="required" class="text-primary ml-2">*</span></label>

        <VueDatePicker
            v-model="model"
            :disabled="disabled"
            :max-date="maxAllowedDate"
            :min-date="minAllowedDate"
            :input-attrs="{ id: id, required: true }"
            :locale="sk"
            :formats="{ input: 'dd.MM.yyyy' }"
            :class="{ 'has-error': error }"
            :enable-time-picker="false"
            auto-apply
        />

        <div v-if="error" class="text-xs text-primary mt-2">{{ error }}</div>
    </div>
</template>
